// extracted by mini-css-extract-plugin
module.exports = {"HeaderContent":"Header_HeaderContent__2xQLZ","MainTitle":"Header_MainTitle__ZMLzj","MainTitleContainer":"Header_MainTitleContainer__pyXHQ"};